var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.description)?_c('div',{staticClass:"d-flex justify-space-between align-center tp-text-body-gray"},[_c('div',[_c('div',{staticClass:"restaurant-description",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.description))}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }